import React, { useState, useEffect } from "react";
import getLocalData from "../../lib/getLocalData";

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const handleClickAccept = () => {
    localStorage.setItem("accept-cookie", "true");
    setShowBanner(false);
  };

  useEffect(() => {
    if (typeof localStorage) {
      const acceptCookie = getLocalData("accept-cookie");

      if (!acceptCookie) {
        setShowBanner(true);
      }
    }
  }, [typeof localStorage]);

  return (
    (showBanner && (
      <div className="cookie-banner d-flex align-items-center">
        <div className="description-section">
          <p className="first">
            By using our site you agree to our use of cookies (not the edible
            kind...).
          </p>
          <a href="/cookies" className="last">
            {" "}
            Learn more about our cookies policy
          </a>
        </div>
        <div onClick={handleClickAccept} className="button-section">
          <button>Accept</button>
        </div>
      </div>
    )) || <noscript />
  );
};

export default CookieBanner;
